<!-- With Flag Template for prelogin header -->
@if (theme === 'withFlag') {
  <div class="d-inline dropright" dropdown>
    <a class="p-2 px-4 text-primary-anchor b1-r" dropdownToggle>
      <img src="assets/img/flag/flag-{{ selectedLanguage.code }}.svg" class="img-fluid mb-1" width="20">
      {{ selectedLanguage.code | uppercase }}
      <i class="fa-regular fa-chevron-down fa-gray fa-normal"></i>
    </a>
    <div *dropdownMenu class="dropdown-menu dropdown-menu-left animated fadeIn" id="profile-dropdown" role="menu">
      @for (language of languages; track language) {
        <a class="nav-link robot_language_{{language.code}}"
          (click)="setLanguage(language.code)">
          @if (selectedLanguage === language) {
            <i class="fa-regular fa-check fa-gray fa-normal"></i>
          }
          {{ language.text | translate }}
        </a>
      }
    </div>
  </div>
}
<!-- With Border Template for settings -->
@if (theme === 'withBorder') {
  <select class="form-control form-control-select-settings" (change)="setLanguage($event.target.value)">
    <option class="d-none"></option>
    @for (language of languages; track language; let i = $index) {
      <option class="robot_language_{{language.code}}"
        [selected]="selectedLanguage.code === language.code" value="{{language.code}}">
        {{ language.text | translate }}
      </option>
    }
  </select>
}